
<div class="ceate-local-notification-container">
    <dl-edit-workflow></dl-edit-workflow>
    <dl-qn-sbn-side-navigation class="section" (updateBtnState)="onSideNavItemClicked($event)">
        <router-outlet sidecontent></router-outlet>
    </dl-qn-sbn-side-navigation>
    
    <dl-button-action-bar [btnState]="btnCurrentState" (stepButton)="onPrevNextBtnClicked($event)"></dl-button-action-bar>
</div>
